export const getLensesTutorialFromStorage = (): string | null => localStorage.getItem('lensesTutorial');
